import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 


import {AdminDisabledGuard, AuthAdminGuard, AuthGuard} from "./shared/auth/auth.guard";
import {PagesComponentComponent} from "./pages/pages-component.component";
import {HomePageComponent} from "./pages/home-page/home-page.component";
import {AdsComponent} from "./pages/personal/ads/ads.component";
import {WishlistComponent} from "./pages/personal/wishlist/wishlist.component";
import {InfoComponent} from "./pages/personal/info/info.component";
import {MyAdsComponent} from "./pages/personal/my-ads/my-ads.component";
import {PersonalComponent} from "./pages/personal/personal.component";
import {CreateAdvComponent} from "./pages/create-adv/create-adv.component";
import {MainCategoryComponent} from "./pages/create-adv/main-category-component/main-category.component";
import {CarAdvFormComponent} from "./pages/create-adv/car-adv-form/car-adv-form.component";
import {ProductsComponent} from "./pages/products/products.component";
import {AboutComponent} from "./pages/about/about.component";
import {PrivacyComponent} from "./pages/privacy/privacy.component";
import {TermsComponent} from "./pages/terms/terms.component";
import {TrendsComponent} from "./pages/trends/trends.component";
import {VipDashboardComponent} from "./pages/personal/vip-dashboard/vip-dashboard.component";
import {PersonalShellComponent} from "./pages/personal/personal-shell/personal-shell.component";
import {VipSubscriptionComponent} from "./pages/personal/vip-subscription/vip-subscription.component";
import {InquiriesComponent} from "./pages/personal/inquiries/inquiries.component";
import {BenefitsComponent} from "./pages/personal/benefits/benefits.component";

import {ShopComponent} from "./pages/shop/shop.component";
import {SingleComponent} from "./pages/single/single.component";
import {ProductComponent} from "./pages/product/product.component";
import {SellerProfileComponent} from "./pages/seller/seller-profile.component";
import {StoreComponent} from "./pages/personal/store/store.component";
import {FollowersComponent} from "./pages/personal/followers/followers.component";
import {FeedComponent} from "./pages/personal/feed/feed.component";
import {CartComponent} from "./pages/cart/cart.component";



export const routes: Routes = [
    { 
        path: '', 
        component: PagesComponentComponent, children: [
            { path: '', component: HomePageComponent },
            { path: 'products', component: ProductsComponent },
            { path: 'product', component: ProductComponent},
            { path: 'shop/:id', component: ShopComponent},
            { path: 'shop/:id/category/:id', component: ShopComponent},
            { path: 'single/:id', component: ProductComponent},
            { path: 'personal',
                canActivate: [AuthGuard],
                component: PersonalShellComponent,
                children:[
                    {
                        path: 'vip-dashboard',
                        component: VipDashboardComponent,
                    },
                    {
                        path: '', // child route path
                        component: AdsComponent, // child route component that the router renders
                    },
                    {
                        path: 'user-info',
                        component: InfoComponent,
                    },
                    {
                        path: 'feed',
                        component: FeedComponent,
                    },
                    {
                        path: 'followers',
                        component: FollowersComponent,
                    },
                    {
                        path: 'store',
                        component: StoreComponent,
                    },
                    {
                        path: 'wishlist',
                        component: WishlistComponent,
                    },
                    {
                        path: 'my-ads',
                        component: MyAdsComponent,
                    },
                    {
                        path: 'vip-subscription',
                        component: VipSubscriptionComponent,
                    },
                    // SCRUM-312 + 328 - "ההטבות שלי" (coupon benefits). The backend's
                    // coupon notifications link to /personal/benefits.
                    {
                        path: 'benefits',
                        component: BenefitsComponent,
                    },
                    // In-site inquiries (buyer ↔ seller), relayed to WhatsApp
                    {
                        path: 'inquiries',
                        component: InquiriesComponent,
                    },
                    {
                        path: 'inquiries/:id',
                        component: InquiriesComponent,
                    },
                ]
            },
            // AI flyer landing pages (coupon campaigns) - back-end app `flyers`.
            // preview/:token is the admin editor's iframe (signed 15-min token).
            {
                path: 'promo/preview/:token',
                data: { preview: true },
                loadComponent: () =>
                import('./pages/promo/promo-page.component').then(m => m.PromoPageComponent),
            },
            {
                path: 'promo/:slug',
                loadComponent: () =>
                import('./pages/promo/promo-page.component').then(m => m.PromoPageComponent),
            },
            {
                path: 'search',
                loadComponent: () =>
                import('./components/search-bar/search-page.component').then(m => m.SearchPageComponent),
                // data: { fullscreen: true, anim: 'search' }
            },
            {
                path: 'publish',
                canActivate: [AuthGuard],
                component: CreateAdvComponent, // this is the component with the <router-outlet> in the template
                children: [
                    {
                        path: '', // child route path
                        component: MainCategoryComponent, // child route component that the router renders
                    },
                    {
                        path: 'car', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'nadlan', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'sale2', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'required', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'cellular', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'nadlanbusiness', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'boybaby', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'fashion', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'furniture', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'coworker', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'pet', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },
                    {
                        path: 'teacher', // child route path
                        component: CarAdvFormComponent, // child route component that the router renders
                    },{
                        path: 'internalads', // child route path
                        component: CarAdvFormComponent,
                        canActivate: [AuthAdminGuard],
                    },
                ],
            },
            { path: 'contact', loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule), data: { breadcrumb: 'Contact' } },
            { path: 'seller/:id', component: SellerProfileComponent, data: { breadcrumb: 'Seller' } },
            { path: 'about',   component: AboutComponent },
            { path: 'privacy', component: PrivacyComponent },
            { path: 'terms',   component: TermsComponent },
            { path: 'trends',  component: TrendsComponent, canActivate: [AuthGuard] },
            { path: 'cart',    component: CartComponent },
        ]
    },
    { path: 'demo', loadChildren: () => import('./demo/demo.module').then(m => m.DemoModule), },
    // Admin was moved to a separate project. Keep its source files in this
    // repository for now, but do not expose or lazy-load either old entry URL.
    { path: 'landing', loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule) },
    {
        path: 'admin',
        canMatch: [AdminDisabledGuard],
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
    },


];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabledBlocking' // for one load page, without reload
    // useHash: true
})
    ],
    declarations: [
    ],
    exports: [
        RouterModule,
    ]
})
export class AppRoutingModule { }
